
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n487Child = []
  var n488Child = []
  var n489Child = []
  n489Child = n489Child.concat(text(t('.state_name')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n489 = h('label', props, n489Child)
  n488Child.push(n489)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n488 = h('div', props, n488Child)
  n487Child.push(n488)
  var n490Child = []
  if(shadow.names.indexOf("") == -1) {
    shadow.names.push("")
  }
  var v491 = shadow.names
  Object.keys(v491).forEach(function (index) {
    var value = v491[index]
    var n492Child = []
    var n493Child = []
    var n494Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "text"},{name:'name', val: `names[${index}]`},{name:'value', val: value}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n494 = h('input', props, n494Child)
    n493Child.push(n494)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n493 = h('div', props, n493Child)
    n492Child.push(n493)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'key', val: `names[${index}]`}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n492 = h('div', props, n492Child)
    n490Child.push(n492)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n490 = h('div', props, n490Child)
  n487Child.push(n490)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n487 = h('div', props, n487Child)
  n0Child.push(n487)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  